import React, { useRef } from 'react';

interface SwipeGestureProps {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  threshold?: number; // minimum distance for a swipe
  restrain?: number; // maximum perpendicular distance
}

export const useSwipeGesture = ({
  onSwipeLeft,
  onSwipeRight,
  threshold = 100,
  restrain = 100,
}: SwipeGestureProps) => {
  const startX = useRef<number>(0);
  const startY = useRef<number>(0);
  const distX = useRef<number>(0);
  const distY = useRef<number>(0);
  const elapsedTime = useRef<number>(0);
  const startTime = useRef<number>(0);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    // Don't handle swipe if touching a button or interactive element
    const target = e.target as HTMLElement;
    if (target.tagName === 'BUTTON' || target.closest('button')) {
      return;
    }
    
    const touchObj = e.changedTouches[0];
    startX.current = touchObj.pageX;
    startY.current = touchObj.pageY;
    startTime.current = new Date().getTime();
    e.preventDefault();
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    // Don't prevent default if touching a button
    const target = e.target as HTMLElement;
    if (target.tagName === 'BUTTON' || target.closest('button')) {
      return;
    }
    e.preventDefault(); // prevent scrolling when inside DIV
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    // Don't handle swipe if touching a button
    const target = e.target as HTMLElement;
    if (target.tagName === 'BUTTON' || target.closest('button')) {
      return;
    }
    
    const touchObj = e.changedTouches[0];
    distX.current = touchObj.pageX - startX.current;
    distY.current = touchObj.pageY - startY.current;
    elapsedTime.current = new Date().getTime() - startTime.current;
    
    // Check if swipe meets the minimum requirements
    if (elapsedTime.current <= 1000 && Math.abs(distX.current) >= threshold && Math.abs(distY.current) <= restrain) {
      if (distX.current > 0 && onSwipeRight) {
        onSwipeRight();
      } else if (distX.current < 0 && onSwipeLeft) {
        onSwipeLeft();
      }
    }
    e.preventDefault();
  };

  const swipeHandlers = {
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
  };

  return swipeHandlers;
};